import styled from 'styled-components/macro';

export const Container = styled.div`
  tbody {
    td {
      padding: 0;
    }
  }
`;
